






































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { BatchEventDetailsDto } from '@/models/batch/BatchEventDetailsDto';
import { DataGrid } from '@questelservices/common-vue';
import DevExpress from 'devextreme';
import { DxColumn, DxEditing } from 'devextreme-vue/data-grid';
import { DxButton, DxLoadPanel } from 'devextreme-vue';
import { BatchService } from '../../service/BatchService';
import { BatchEventService } from '../../service/BatchEventService';
import dialog from 'devextreme/ui/dialog';
import _ from 'lodash';
import { BatchEventTypeEnum } from '@/models/batch/BatchEventTypeEnum';


@Component({
  components: {
    DataGrid,
    DxColumn,
    DxButton,
    DxLoadPanel,
    DxEditing
  }
})
export default class BatchEventDetails extends Vue {
  $refs: Vue['$refs'] & {
    batchEventDetailsDataGrid?: DataGrid;
  } = {};

  @Prop({ required: true })
  batchEvents!: Array<BatchEventDetailsDto>;

  batchEventDetails: Array<BatchEventDetailsDto> = this.batchEvents;

  batchService: BatchService = new BatchService();
  batchEventService: BatchEventService = new BatchEventService();

  updatingBatches: boolean = false;

  private get dxDataGrid(): DevExpress.ui.dxDataGrid {
    return (this.$refs.batchEventDetailsDataGrid as any).$refs.dxDataGrid.instance;
  }

  private get dataStoreOptions() : DevExpress.data.CustomStoreOptions {
    return {
      loadMode: 'raw',
      key: 'BatchId',
      load: () => { return this.batchEventDetails; },
      update: (key, values) => {
        return this.updateBatchEvent(key, values)
          .catch((e: any) => {
            if(e && e.Message) {
              throw e.Message;
            }
            throw "An error occurred.";
          });
      },
    }
  }

  async updateBatchEvent(batchId: Guid, batchEventDto: BatchEventDetailsDto)
  {
    // validate that batch event time is in between adjacent events    
    let batchEventIndex = this.batchEvents.findIndex(be => be.BatchEventId == batchEventDto.BatchEventId);
    let prevBatchEvent = this.batchEvents[batchEventIndex - 1];
    let nextBatchEvent = this.batchEvents[batchEventIndex + 1];

    if (prevBatchEvent && prevBatchEvent.ScheduledDate > batchEventDto.ScheduledDate) {
      dialog.alert("The Scheduled Date of a batch event must occur after the previous event's Scheduled Date.", "Error");
      return;
    }
    if (nextBatchEvent && nextBatchEvent.ScheduledDate < batchEventDto.ScheduledDate) {
      dialog.alert("The Scheduled Date of a batch event must occur before the next event's Scheduled Date.", "Error");
      return;
    }


    this.batchEvents[batchEventIndex].ScheduledDate = batchEventDto.ScheduledDate;
    return this.batchEventService.updateBatchEvent(batchEventDto.BatchEventId, batchEventDto)
  }

  rowUpdating(e: any) {
    // Add back any data not edited
    e.newData = Object.assign({}, e.oldData, e.newData);      
  }

  saveEditData(): void {
    if (this.dxDataGrid) {
      this.dxDataGrid.saveEditData();
    }
  }

  async processBatchEvent(batchId: Guid, batchEventId: Guid) {
    this.updatingBatches = true;
    await this.batchService.processBatchEvent(batchEventId).catch(await this.processBatchEventError);
    this.batchEventDetails = await this.batchService.getBatchEvents(batchId);
    await this.dxDataGrid.refresh(true);
    this.updatingBatches = false;
  }

  async processBatchEventError(error: any) {
    let message = 'An error occurred processing the batch event';
    message += error.Message ? ': ' + error.Message : '.';
    await dialog.alert(message, 'Error');
  }

  showProcessButton(batchEvent: BatchEventDetailsDto)
  {
    let result = false;

    if (batchEvent.ProcessedDate == null &&
      (batchEvent.BatchEventTypeId == BatchEventTypeEnum.DataDeadline || 
        batchEvent.BatchEventTypeId == BatchEventTypeEnum.AutoCoding))
    {
      result = true;
    }
    
    return result;
  }
}
